export const MAIN_BOARD_TOP = 156;
export const KIOSK_BOARD_TOP = 112;
export const KIOSK_WIDTH = 640;
export const KIOSK_HEIGHT = 244;

export function mainBoardHeight(gates: number) { return 164 + Math.min(4, Math.max(1, gates)) * 48; }

export const mainBoardStyle = `
    .billboard{height:var(--board-height,212px);padding:14px;border:3px solid #7197a9;background:#152a38;box-shadow:none;border-radius:16px}
    header{height:50px;margin-bottom:8px}.board-title{font-size:52px;--sf-ink:#fff1c5}
    .board-meta,.maker{display:none}
    .headings,.flight-row{grid-template-columns:148px 354px 80px 266px;column-gap:18px}
    :host([data-timetable=on]) .headings,:host([data-timetable=on]) .flight-row{grid-template-columns:120px 240px 60px 288px 124px;column-gap:16px}
    :host([data-timetable=on]) .flight-row{font-size:34px}
    :host([data-timetable=on]) .flight-row .status{font-size:26px}
    :host([data-timetable=on]) .flight-row>:nth-child(2){font-size:28px}
    .headings{height:28px;font-size:26px;letter-spacing:0;color:#bed2d9;padding:0}
    .departures{height:var(--rows-height,48px)}
    .flight-row{font-size:42px;height:48px;padding:2px 0;margin:0}
    .flight-row>:nth-child(3) .sf-cell:nth-child(n+2){display:none}
    footer{margin-top:8px;padding-top:8px}.board-message{font-size:28px}
    .sf-top{background:linear-gradient(#38515d,#243a48)}.sf-bottom{background:#213643}
    .sf-hinge{height:.05em;top:.415em;background:#0a1b27}
    .sf-cell{border-radius:2px;box-shadow:inset 0 0 0 1px #56707c}
    .sf-top{box-shadow:inset 0 1px 1px #63808b}
`;

export const kioskBoardStyle = `
    ${mainBoardStyle}
    .billboard{width:640px;height:244px}
    header{height:46px}.board-title{font-size:52px}
    .headings{display:none}.departures{height:106px}
    .flight-row{height:106px;grid-template-columns:150px 70px 1fr;grid-template-rows:54px 44px;gap:8px 12px}
    :host([data-timetable=on]) .flight-row{grid-template-columns:150px 70px 1fr;font-size:42px}
    :host([data-timetable=on]) .time{display:none}
    .flight-row>:nth-child(1){grid-area:2/1;font-size:38px}
    .flight-row>:nth-child(2){grid-area:2/2/3/4;font-size:44px}
    .flight-row>:nth-child(3){grid-area:1/1/2/3;font-size:64px;align-items:center;gap:16px}
    .flight-row>:nth-child(3)::before{content:'GATE';font:700 32px system-ui;color:#c1d9df;letter-spacing:2px}
    .flight-row>:nth-child(4){grid-area:1/3;font-size:32px}
    :host([data-timetable=on]) .flight-row .status{font-size:32px}
    :host([data-timetable=on]) .flight-row>:nth-child(2){font-size:44px}
`;

/** A gate board shows its six-tile title (`GATE X`) and nothing else; its surface is cut to that width. */
export const GATE_BOARD_WIDTH = 720;
/** Its width over the doorway in world units (the case adds a rim). */
export const GATE_BOARD_SPAN = 77;
export const gateBoardStyle = `
    .billboard{width:${GATE_BOARD_WIDTH}px;height:188px;padding:22px 30px;background:#173449;border:8px solid #a3c1c8;border-radius:18px;box-shadow:none}
    header{height:140px;margin:0;justify-content:center}.board-title{font-size:140px;--sf-ink:#fff5d7}
    .board-title .sf-cell:nth-child(n+7){display:none}
    .board-meta,.headings,.departures,footer{display:none}
    :host([data-power=off]) .sf-row{opacity:.5}
`;
